const extend = (map) => {
    class EnumHelper {
        constructor() {
            this.getName = (id) => {
                const value = Number.isNaN(+id) ? id : +id;
                return (map.get(value) || { name: '' }).name;
            };
            this.keys = () => {
                return Array.from(map.values()).map(({ name }) => name);
            };
            this.values = () => {
                return Array.from(map.keys());
            };
        }
    }
    return new EnumHelper();
};
export { extend };
export default extend;
